import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { TextField, Button, Typography, Grid, InputLabel, CircularProgress } from "@mui/material";
import { Link } from "react-router-dom";
import Logo from "../assets/logo.jpg";
import "../components/App.css";
import axios from "axios";
import toast from "react-hot-toast";
import { API_BASE_URL } from "../config/config";
import BevHeader from "../components/BevHeader";
import BevFooter from "../components/BevFooter";

const ForgotPassword = () => {
  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/forgot-password`, values);
      toast.success(response.data.message);
      resetForm();
    } catch (error) {
      toast.error(error.response?.data?.error || "Unable to send reset link. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <BevHeader />
      <div className="login-container">
        <div className="login-form">
          <img src={Logo} alt="Logo" width={120} className="form-logo" />
          <Typography variant="h6" component="h2" gutterBottom textAlign="center" marginBottom="20px" paddingBottom="10px" borderBottom="1px solid #ccc">
            Forgot Password
          </Typography>
          <Typography variant="body2" textAlign="center" marginBottom="20px" color="text.secondary">
            Enter your email address and we will send you a link to reset your password.
          </Typography>
          <Formik
            initialValues={{ email: "" }}
            validationSchema={Yup.object({
              email: Yup.string().email("Invalid email address").required("Email is required"),
            })}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting }) => (
              <Form>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <InputLabel htmlFor="email">Email</InputLabel>
                    <Field
                      as={TextField}
                      name="email"
                      size="small"
                      variant="outlined"
                      fullWidth
                      disabled={isSubmitting}
                    />
                    <ErrorMessage name="email" component="div" className="login-error" />
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      type="submit"
                      variant="contained"
                      color="success"
                      fullWidth
                      disabled={isSubmitting}
                      startIcon={isSubmitting ? <CircularProgress size={18} color="inherit" /> : null}
                    >
                      {isSubmitting ? "Sending..." : "Send Reset Link"}
                    </Button>
                  </Grid>
                  <Grid item xs={12} className="login-links">
                    <Link className="login-link" to="/login">Back to Login</Link>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        </div>
      </div>
      <BevFooter />
    </>
  );
};

export default ForgotPassword;
